export const GoogleIcon = () => {
    return (
        <>
            <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.99995 4.66667C11.3472 4.66667 12.5843 5.12794 13.5719 5.89505L16.6028 3.00341C14.8406 1.44996 12.5338 0.5 9.99995 0.5C6.16028 0.5 2.83051 2.6666 1.15479 5.84154L4.52515 8.50232C5.34159 6.26614 7.48118 4.66667 9.99995 4.66667Z"
                    fill="#F44336"
                />
                <path
                    d="M19.9134 11.7515C19.9655 11.3418 20 10.9239 20 10.5C20 9.78512 19.9219 9.08901 19.7794 8.41666H10V12.5833H15.4052C14.9679 13.7198 14.1894 14.6815 13.1983 15.3495L16.5812 18.0202C18.3745 16.4462 19.6016 14.242 19.9134 11.7515Z"
                    fill="#2196F3"
                />
                <path
                    d="M4.16667 10.5C4.16667 9.79714 4.29738 9.12636 4.5252 8.50233L1.15484 5.84155C0.420278 7.23336 0 8.81681 0 10.5C0 12.1644 0.412547 13.7303 1.13185 15.1108L4.50648 12.4466C4.29036 11.837 4.16667 11.1837 4.16667 10.5Z"
                    fill="#FFC107"
                />
                <path
                    d="M9.99999 16.3333C7.46205 16.3333 5.30867 14.7096 4.50647 12.4466L1.13184 15.1108C2.79937 18.3112 6.1415 20.5 9.99999 20.5C12.5231 20.5 14.824 19.5627 16.5812 18.0203L13.1983 15.3496C12.2843 15.9658 11.1903 16.3333 9.99999 16.3333Z"
                    fill="#00B060"
                />
                <path
                    opacity="0.1"
                    d="M10.0001 20.2917C7.05699 20.2917 4.41065 19.0774 2.53967 17.1428C4.37119 19.1982 7.03044 20.5 10.0001 20.5C12.9422 20.5 15.5794 19.2239 17.4068 17.2006C15.5414 19.1039 12.9151 20.2917 10.0001 20.2917Z"
                    fill="black"
                />
                <path
                    opacity="0.1"
                    d="M10 12.375V12.5833H15.4052L15.4896 12.375H10Z"
                    fill="black"
                />
                <path
                    d="M19.9954 10.6225C19.9961 10.5815 20 10.5411 20 10.5C20 10.4883 19.9982 10.4771 19.9982 10.4655C19.9976 10.5179 19.995 10.5698 19.9954 10.6225Z"
                    fill="#E6E6E6"
                />
                <path
                    opacity="0.2"
                    d="M10 8.41666V8.62499H19.8213C19.8082 8.55622 19.7939 8.48491 19.7794 8.41666H10Z"
                    fill="#FEFEFE"
                />
                <path
                    d="M19.7794 8.41667H10V12.5833H15.4052C14.5646 14.768 12.481 16.3333 10 16.3333C6.77836 16.3333 4.16667 13.7216 4.16667 10.5C4.16667 7.27831 6.77836 4.66667 10 4.66667C11.1682 4.66667 12.2449 5.02555 13.1571 5.61724C13.2967 5.70798 13.4408 5.79317 13.5719 5.89505L16.6029 3.00341L16.5345 2.95082C14.7808 1.43089 12.5029 0.5 10 0.5C4.47713 0.5 0 4.97713 0 10.5C0 16.0228 4.47713 20.5 10 20.5C15.0981 20.5 19.2962 16.6823 19.9134 11.7515C19.9655 11.3418 20 10.9239 20 10.5C20 9.78513 19.9219 9.08902 19.7794 8.41667Z"
                    fill="url(#paint0_linear)"
                />
                <path
                    opacity="0.1"
                    d="M13.1571 5.40892C12.2449 4.81723 11.1682 4.45834 9.99996 4.45834C6.77832 4.45834 4.16663 7.06999 4.16663 10.2917C4.16663 10.3268 4.1671 10.3543 4.16771 10.3893C4.22391 7.21627 6.81347 4.66668 9.99996 4.66668C11.1682 4.66668 12.2449 5.02556 13.1571 5.61725C13.2967 5.70799 13.4407 5.79318 13.5719 5.89506L16.6028 3.00342L13.5719 5.68673C13.4407 5.58485 13.2967 5.49965 13.1571 5.40892Z"
                    fill="black"
                />
                <path
                    opacity="0.2"
                    d="M10 0.708333C12.4792 0.708333 14.7358 1.62366 16.4827 3.118L16.6029 3.00341L16.5112 2.92356C14.7575 1.40363 12.5029 0.5 10 0.5C4.47713 0.5 0 4.97713 0 10.5C0 10.5351 0.00488283 10.5691 0.00523883 10.6042C0.0616963 5.12987 4.51228 0.708333 10 0.708333Z"
                    fill="#FEFEFE"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear"
                        x1="0"
                        y1="10.5"
                        x2="20"
                        y2="10.5"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="white" stopOpacity="0.2" />
                        <stop offset="1" stopColor="white" stopOpacity="0" />
                    </linearGradient>
                </defs>
            </svg>
        </>
    );
};
